import { useMyTraining } from '../../../../lib/api/swrApi';
import ContinueTrainingView, { ContinueTrainingViewItems } from '../../base/ContinueTrainingView/ContinueTrainingView';
import { useId } from '../../../../lib/hooks/useId';
import { useDevice } from '../../../../lib/hooks/device';
import { MappedAEMProperties } from '../../../../types';
import { CourseCardProps } from '../../base/CourseCard/CourseCard.types';
import SkeletonCarousel from '../../base/Carousel/SkeletonCarousel';
import ErrorInfo from '../../base/ErrorInfo/ErrorInfo';
import { ApiParamTrainingStatus } from '../../../../lib/constants/courses';

export type ContinueTrainingProps = {
  limit?: number;
  heading?: string;
} & MappedAEMProperties;

export const validateAndMapData = (data: CourseCardProps[]): ContinueTrainingViewItems[] => {
  return data
    .filter(({ type }) => !!type)
    .map(cc => ({
      ...cc,
      progress: cc.progress ?? 0,
    }));
};

const ContinueTraining = ({ limit = 6, heading, id }: ContinueTrainingProps) => {
  const device = useDevice();
  const { data, isValidating, error } = useMyTraining(device === 'desktop' ? limit : Math.min(limit, 6), [
    ApiParamTrainingStatus.InProgress,
    ApiParamTrainingStatus.NotStarted,
  ]);
  const componentId = id ?? useId('continue-training-');

  if (!data?.length && isValidating) {
    return <SkeletonCarousel />;
  }

  if (error) {
    return <ErrorInfo error={error} />;
  }

  if (data === undefined || !data.length) {
    return null;
  }

  return <ContinueTrainingView id={componentId} title={heading} items={validateAndMapData(data)} />;
};

export default ContinueTraining;
